import { images } from '../constants';

const home = [
    {  
        id: 1,
        image: images.home1,
        title: 'A Cup of Tea for Every Mood',
        content: 'Discover the perfect blend of tradition and taste. From soothing green teas to rich black brews, we serve the finest teas for every moment.',
    },
    {
        id: 2,
        image: images.home2,
        title: 'Brewed with Passion and Purity',
        content: 'Savor handpicked leaves, responsibly sourced and expertly brewed. Whether hot or iced, our teas are crafted to refresh and rejuvenate.',
    },
    { 
        id: 3,
        image: images.home3,
        title: 'We Make Tea Moments Memorable',
        content: 'Experience warmth in every sip. Our tea shop is more than a place—it’s a moment of calm, comfort, and community.',
    },
];

export default home;